export default "__VITE_ASSET__Cc4Q5OFV__"